import { Text } from '@belong/ui';
import Icon, { ICONS } from 'components/Icon/Icon';
import { PaymentMethod } from 'models/enums';
import { PAY_AS_YOU_GO_STRINGS } from '../strings';

const STRINGS = PAY_AS_YOU_GO_STRINGS.methodStep;

export type PaymentMethodTypeKey =
  | typeof PaymentMethod.Ach
  | typeof PaymentMethod.CreditCard;

const TILES = [
  {
    key: PaymentMethod.Ach,
    label: STRINGS.achLabel,
    detail: STRINGS.achDetail,
    icon: ICONS.BANK_ACCOUNT.DEFAULT,
    iconSelected: ICONS.BANK_ACCOUNT.INVERSE,
  },
  {
    key: PaymentMethod.CreditCard,
    label: STRINGS.creditCardLabel,
    detail: STRINGS.creditCardDetail,
    icon: ICONS.CREDIT_CARD.DEFAULT,
    iconSelected: ICONS.CREDIT_CARD.INVERSE,
  },
];

type Props = {
  onSelect: (key: PaymentMethodTypeKey) => void;
  selected?: PaymentMethodTypeKey | null;
};

export function PaymentMethodTypeTiles({ onSelect, selected = null }: Props) {
  return (
    <div className="flex w-full flex-col gap-sm md:flex-row">
      {TILES.map((tile) => {
        const isSelected = tile.key === selected;

        return (
          <button
            aria-pressed={isSelected}
            className={`flex h-[198px] cursor-pointer flex-col items-center justify-center gap-2xs rounded border-3 border-solid bg-white p-sm shadow transition-colors duration-200 md:h-[190px] md:flex-1 ${
              isSelected
                ? 'border-navy'
                : 'border-transparent hover:border-navy'
            }`}
            key={tile.key}
            onClick={() => onSelect(tile.key)}
            type="button"
          >
            <Icon icon={isSelected ? tile.iconSelected : tile.icon} />
            <Text className="text-navy" fontWeight="semibold" variant="body">
              {tile.label}
            </Text>
            <Text className="text-navy" variant="p1">
              {tile.detail}
            </Text>
          </button>
        );
      })}
    </div>
  );
}
